module.exports = __webpack_public_path__ + "media/images/country_flags/mu-d22c2a45e8f2984be7910df3e7f58e83.png";